import React from 'react';
import i18n from '../../i18n';
import borders from '@material-ui/system';
import Button from "@material-ui/core/Button/Button";
import Icon from "@material-ui/core/Icon/Icon";
import Grid from "@material-ui/core/Grid/Grid";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Typography from "@material-ui/core/Typography/Typography";
import {FormattedDate, FormattedTime} from "react-intl";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Divider from "@material-ui/core/Divider/Divider";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import Paper from "@material-ui/core/Paper/Paper";
import {Hidden} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles/index";
import Chip from "@material-ui/core/Chip/Chip";
import FormLabel from "@material-ui/core/FormLabel/FormLabel";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import Link from "@material-ui/core/Link/Link";
import Date from "../Formater/Date";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

class AppointmentDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTab: 0
        };
    }

    render() {
        const {appointment, protocols, notes, classes} = this.props;

        return (
            <section>
                <Grid container spacing={16}>
                    <Grid item xs={6}>
                        <Card>
                            <CardContent>
                                <Grid container spacing={8}>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('appointments.board_name')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {appointment.customer.customer_name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('appointments.appointment_name')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {appointment.appointment_name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('appointments.project_number')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {appointment.project_number}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('appointments.day_last_appointment')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        {appointment.day_last_appointment &&
                                        <Typography>
                                            <Date value={appointment.day_last_appointment}/>
                                        </Typography>
                                        }
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('appointments.day_next_appointment')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        {appointment.day_next_appointment &&
                                        <Typography>
                                            <Date value={appointment.day_next_appointment}/>
                                        </Typography>
                                        }
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('appointments.remember_days')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        {appointment.days_before_remember &&
                                        <Typography>
                                            <Date value={appointment.days_before_remember}/>
                                        </Typography>
                                        }
                                        {!appointment.remember &&
                                        <Typography>
                                            {i18n.get('appointments.no_remember')}
                                        </Typography>
                                        }
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('appointments.technician')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {appointment.technician.name}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6}>
                        <Card>
                            <CardContent>
                                <Grid container spacing={8}>
                                    <Grid item xs={12}>
                                        <Typography>
                                            Protokolle
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={8} justify="center" alignItems="center">
                                            {protocols.map(protocol => {
                                                return (
                                                    <React.Fragment>
                                                        <Grid item md={10} xs={8}>
                                                            <Typography component='div'>
                                                                <EllipsisWithTooltip>
                                                                    <FormattedDate value={protocol.created_at}/>
                                                                </EllipsisWithTooltip>
                                                            </Typography>
                                                        </Grid>
                                                        {!appointment.isArchived &&
                                                        <Grid item md={1} xs={2}>
                                                            <Tooltip placement="bottom-end"
                                                                     title={i18n.get('protocols.correct_protocol')}
                                                                     classes={{tooltip: classes.popper}}>
                                                                <IconButton
                                                                    href={`/protocols/correction/${protocol.id}`}
                                                                    className={classes.iconButton}>
                                                                    <Icon className={classes.iconButtonIcon}>edit</Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Grid>
                                                        }
                                                        <Grid item md={1} xs={2}>
                                                            <Tooltip placement="bottom-end"
                                                                     title={i18n.get('protocols.show_protocol')}
                                                                     classes={{tooltip: classes.popper}}>
                                                                <IconButton
                                                                    href={`/protocols/${protocol.id}`}
                                                                    className={classes.iconButton}>
                                                                    <Icon className={classes.iconButtonIcon}>assignment</Icon>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Hidden mdUp>
                                                            <Grid item xs={1}>&nbsp;</Grid>
                                                        </Hidden>
                                                        <Grid item xs={12}>
                                                            <Divider/>
                                                        </Grid>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                {/*<Grid container spacing={16}>*/}
                {/*    <Grid item xs={6}>*/}
                {/*        <Card>*/}
                {/*            <CardContent>*/}
                {/*                <Grid container spacing={8}>*/}
                {/*                    <Grid item xs={12}>*/}
                {/*                        <Typography>*/}
                {/*                            {i18n.get('default.notes')}*/}
                {/*                        </Typography>*/}
                {/*                    </Grid>*/}
                {/*                    {notes.map(note => {*/}
                {/*                        return (*/}
                {/*                            <Grid item xs={12}>*/}
                {/*                                <Card>*/}
                {/*                                    <CardContent>*/}
                {/*                                        <Grid container spacing={8}>*/}
                {/*                                            <Grid item xs={8}>*/}
                {/*                                                <Typography>*/}
                {/*                                                    {note.user.name}*/}
                {/*                                                </Typography>*/}
                {/*                                            </Grid>*/}
                {/*                                            <Grid item xs={4}>*/}
                {/*                                                <Typography>*/}
                {/*                                                    {note.user.created_at}*/}
                {/*                                                </Typography>*/}
                {/*                                            </Grid>*/}

                {/*                                            <Grid item xs={12}>*/}
                {/*                                                <Divider/>*/}
                {/*                                            </Grid>*/}

                {/*                                            <Grid item xs={12}>*/}
                {/*                                                <Typography>*/}
                {/*                                                    {note.note}*/}
                {/*                                                </Typography>*/}
                {/*                                            </Grid>*/}
                {/*                                        </Grid>*/}
                {/*                                    </CardContent>*/}
                {/*                                </Card>*/}
                {/*                            </Grid>*/}
                {/*                        )*/}
                {/*                    })}*/}
                {/*                </Grid>*/}
                {/*            </CardContent>*/}
                {/*        </Card>*/}
                {/*    </Grid>*/}
                {/*</Grid>*/}
            </section>
        )
    }
}

const styles = {
    contractCard: {
        width: '500px',
        margin: 'auto',
    },
    gridDivider: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    linkBoard: {
        backgroundColor: 'grey',
    },
    chipQuali: {
        margin: '5px',
    }
};

export default withStyles(styles)(AppointmentDetails);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Appointments/AppointmentDetails.js